<template>
  <v-main id="cenas">
    <v-container fluid style="overflow: hidden;">
      <div>
        <v-btn
          depressed
          color="#D8E0E6"
          class="gray-button pag-btn return-btn"
          to="https://demo.bigodds.pt"
          ><v-icon size="10" left>$icon-arrow-left</v-icon>Site</v-btn
        >
      </div>
      <!-- CAROUSEL -->
      <v-carousel
        :show-arrows="false"
        hide-delimiter-background
        class="carousel"
        height="100vh"
      >
        <v-carousel-item>
          <v-col class="flex-center" style="background-color: #F7F9FA">
            <div style="width: 100%;">
              <!-- LOGO -->
              <div style="position: absolute; left: 50%; top:84px;">
                <v-img
                  src="../assets/images/logo.svg"
                  style="position: relative; left: -50%;"
                ></v-img>
              </div>
              <!-- BANNER IMAGE -->
              <v-row class="login-img" align="center" justify="center">
                <v-col
                  class="form-col"
                  style="padding: 0;"
                  align="center"
                  justify="center"
                >
                  <div
                    style="display: table-cell; height: calc(100vh - 24px); vertical-align: middle;"
                  >
                    <img
                      src="../assets/images/register.png"
                      style="width:100%; max-width: 500px;"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="flex-center">
                  <v-btn
                    large
                    depressed
                    color="primary"
                    to="/registo"
                    class="regular-btn"
                    style="position: fixed; bottom: 124px;"
                    >Quero registar-me!</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-carousel-item>
        <v-carousel-item>
          <v-col class="flex-center" style="background-color: #F7F9FA">
            <div style="width: 100%;">
              <!-- LOGO -->
              <div style="position: absolute; left: 50%; top:84px;">
                <v-img
                  src="../assets/images/logo.svg"
                  style="position: relative; left: -50%;"
                ></v-img>
              </div>
              <!-- BANNER IMAGE -->
              <v-row class="login-img" align="center" justify="center">
                <v-col
                  class="form-col"
                  style="padding: 0;"
                  align="center"
                  justify="center"
                >
                  <div
                    style="display: table-cell; height: calc(100vh - 24px); vertical-align: middle;"
                  >
                    <img
                      src="../assets/images/login.png"
                      style="width:100%; max-width: 500px;"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="flex-center">
                  <v-btn
                    large
                    depressed
                    color="primary"
                    to="/login"
                    class="regular-btn"
                    style="position: fixed; bottom: 124px;"
                    >Já tenho conta!</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-carousel-item>
      </v-carousel>
      <!-- END CAROUSEL -->
      <v-row style="height: 100%;" class="no-carousel">
        <!-- LOGO -->
        <div style="position: absolute; left: 50%; top:44px;">
          <v-img src="../assets/images/logo.svg"></v-img>
        </div>
        <!-- LEFT COLUMN -->
        <v-col class="left-col flex-center">
          <div style="width: 100%; height: 100%;">
            <v-row style="height: 100%;">
              <v-col class="flex-center">
                <v-img height="65%"
                  src="../assets/images/register.png"
                  contain
                ></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="flex-center">
                <v-btn
                  large
                  depressed
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  to="/registo"
                  class="regular-btn"
                  style="position: fixed; bottom: 88px;"
                  >Quero registar-me!</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- RIGHT COLUMN -->
        <v-col class="right-col flex-center">
          <div style="width: 100%; height: 100%;">
            <v-row style="height: 100%;">
             <v-col class="flex-center">
                <v-img height="65%" style="position:relative; top:-3%;"
                  src="../assets/images/login.png"
                  aspect-ratio="1"
                  contain
                ></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="flex-center">
                <v-btn
                  large
                  depressed
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  to="/login"
                  class="regular-btn"
                  style="position: fixed; bottom: 88px;"
                  >Já tenho conta!</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="snackBarTimeout" color="error">{{
      errorText
    }}</v-snackbar>
  </v-main>
</template>

<style scoped>
.v-main {
  height: calc(100vh - 2px);
  padding: 0px 256px 0px 0px;
  position: absolute;
  width: 100vw;
  top: -14px;
  padding: 0 !important;
  left: 0;
}
.container {
  height: 100%;
  padding: 0 !important;
}
.left-col {
  flex: 0 0 50%;
  max-width: 50%;
  position: relative;
  background-color: #ffffff;
}
.return-btn {
  position: fixed;
  top: 24px;
  left: 16px;
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #9aabb8;
  text-transform: capitalize;
  width: 176px;
  z-index: 99;
}
.right-col {
  flex: 0 0 50%;
  max-width: 50%;
  background-color: #ffffff;
}
.big-title {
  font-family: Gilroy-SemiBold;
  font-size: 20px;
  line-height: 24px;
}
.small-title {
  font-family: Gilroy-SemiBold;
  color: #6d818f;
  font-size: 14px;
  line-height: 16px;
}
.v-list-item {
  min-height: initial !important;
}
.light-text {
  color: #bcc5cc !important;
  font-size: 12px;
  line-height: 16px;
}
.align-bottom {
  margin-top: 0;
}
.v-image >>> .v-responsive__sizer {
  max-height: 250px !important;
}
.login-img {
  display: none;
}
.carousel {
  display: none;
}
.no-carousel {
  display: flex;
}
@media only screen and (max-width: 768px) {
  .carousel {
    display: block;
    background: #f7f9fa !important;
  }
  .no-carousel {
    display: none;
  }
  .left-col {
    display: none;
  }
  .right-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .login-img {
    display: flex;
  }
  .return-btn {
    width: 106px;
  }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #26ab5e !important;
  color: #ffffff !important;
}
.v-btn:not(.v-btn--round).v-size--large {
  height: 48px;
}
</style>

<script>
import { FirebaseApp } from "../auth";

export default {
  props: {
    source: String
  },
  components: {},
  data: () => ({
    validEmail: false,
    emailError: false,
    errorText: "",
    showPassword: false,
    snackbar: false,
    snackBarTimeout: 3000,
    loading: false,
    input: {
      username: "",
      password: ""
    },
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: v =>
        /.+@.+\..+/.test(v) || "The email and password you entered don't match"
    }
  }),
  methods: {}
};
</script>